module.exports = __webpack_public_path__ + "img/rio_grande_do_sul.6b088f9a.jpg";